/* Mensajes por cliente (21-oct-2026): decide qué pop up del tema ve cada visitante.
   Maqueta aprobada por Andrés: https://claude.ai/artifact/U7xn9YYHVe3F35cKUygj7u

   Los mensajes son Flyouts nativos del grupo del footer (sections/flyout.liquid). Cada uno lleva un
   ajuste "Para quién"; con un valor distinto de Todos el tema no lo abre (data-delay-type="hai") y lo
   abre este archivo. Reglas:

   1. Un mensaje por visita: el primero de la lista del grupo que le corresponda a la persona (el orden
      del editor es la prioridad).
   2. Quién es, de más a menos certeza: la sesión del cliente (snippets/hai-quien.liquid, pedidos
      incluidos), y si no hay sesión, lo que recuerda este navegador en localStorage `hai-quien`:
      compró (lo marcan una sesión anterior, un carrito que llegó desde un enlace nuestro con el
      atributo `origen`, y la compra que deja el píxel del pago en `hai-compra`) y dejó su correo (el
      "Listo…" de un formulario de newsletter).
   3. Cuándo: a los N segundos de la visita (sumando páginas, nunca antes de 3 s en la página actual) o
      antes, al desplazar hasta el Retraso del flyout, si está marcado. Nunca con un drawer, el
      buscador o un modal abiertos (el tema quita body.hidden al abrir un flyout y rompería el drawer).
   4. Dónde: en el teléfono, nada en la ficha de producto (taparía la barra de compra); los avisos
      compactos tampoco en el carrito. "No mostrar si ya tiene productos en el carrito" se revisa al
      abrir, con el carrito en vivo.
   5. Al cerrarlo, el tema deja su cookie por la frecuencia del flyout y no vuelve en ese plazo.
   6. "Entrar" en un aviso de cliente sin sesión: la persona inicia sesión y vuelve a la misma página;
      ahí, ya con sesión, sale de inmediato el aviso con su último pedido (excepción a la regla 1).

   Lo que antes hacía assets/hai-captura.js sigue aquí: tras el "Listo…" de cualquier formulario de
   newsletter aparece "Entrar a mi cuenta" (el 10 % se entrega en la cuenta, no en la tienda), y si el
   éxito fue en el flyout se abre para que se vea.

   Para revisar sin cumplir las reglas: `?hai_mensaje=<clave>` abre el flyout de esa sección (por
   ejemplo `?hai_mensaje=hai_te_espera`); `?hai_captura=abrir|exito` sigue funcionando para el 10 %.
   Con sesión iniciada, Liquid no imprime los mensajes que la sesión contradice.

   Todo con guardas y en silencio: si algo falla, no sale ningún mensaje y la tienda sigue igual. */

(function () {
  'use strict';

  if (window.__haiMensajes) return;
  window.__haiMensajes = true;

  var script = document.currentScript || document.querySelector('script[src*="hai-mensajes"]');
  var TEXTO_EXITO = (script && script.getAttribute('data-exito')) || 'Listo.';
  var TEXTO_CUENTA = (script && script.getAttribute('data-cuenta')) || 'Entrar a mi cuenta';
  var MIN_EN_PAGINA = 3000;
  var UN_ANO = 365 * 24 * 60 * 60;

  function leerLS(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function guardarLS(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
  function leerSS(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function guardarSS(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
  function borrarSS(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* sin almacenamiento */ } }
  function hoy() { return new Date().toISOString().slice(0, 10); }

  function cuandoExista(fn) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('promo-popup').then(fn, fn);
    } else {
      fn();
    }
  }

  function clave(el) {
    var id = el.getAttribute('data-section-id') || '';
    var i = id.lastIndexOf('__');
    return i >= 0 ? id.slice(i + 2) : id;
  }

  function tieneCookie(el) {
    var id = el.getAttribute('data-section-id');
    if (!id) return false;
    return document.cookie.split('; ').some(function (c) { return c.indexOf(id + '=') === 0; });
  }

  function borrarCookie(el) {
    var id = el.getAttribute('data-section-id');
    try { document.cookie = id + '=; max-age=0; path=/'; } catch (e) { /* sin cookies */ }
  }

  function fijarCookieLarga(el) {
    var id = el.getAttribute('data-section-id');
    try { document.cookie = id + '=true; max-age=' + UN_ANO + '; path=/'; } catch (e) { /* sin cookies */ }
  }

  /* ---- 1. Quién es ---- */

  var srv = {};
  try {
    var nodo = document.getElementById('hai-quien');
    srv = nodo ? JSON.parse(nodo.textContent || '{}') : {};
  } catch (e) { srv = {}; }
  var pedidos = parseInt(srv.pedidos, 10) || 0;
  var carrito = parseInt(srv.carrito, 10) || 0;

  var quien = leerLS('hai-quien') || {};
  var cambio = false;
  function marcar(k, v) {
    if (quien[k] !== v) { quien[k] = v; cambio = true; }
  }

  if (srv.sesion && pedidos > 0) {
    if (!quien.compro) marcar('compro', hoy());
    marcar('pedidos', pedidos);
  }
  if (srv.origen && !quien.compro) marcar('compro', hoy());
  var compra = leerLS('hai-compra');
  if (compra && compra.fecha && quien.ultimaCompra !== compra.fecha) {
    if (!quien.compro) marcar('compro', hoy());
    marcar('ultimaCompra', compra.fecha);
  }

  /* ---- 2. El "Listo…" de un formulario de newsletter ---- */

  /* Solo los formularios de newsletter ({% form 'customer' %} con la etiqueta), no el de contacto. */
  function exitosNewsletter() {
    return Array.prototype.filter.call(document.querySelectorAll('form .success-color'), function (mensaje) {
      var form = mensaje.closest('form');
      return !!(form && form.querySelector('input[name="form_type"][value="customer"], input[name="contact[tags]"]'));
    });
  }

  function anotarCuenta() {
    exitosNewsletter().forEach(function (mensaje) {
      var form = mensaje.closest('form');
      if (!form || form.querySelector('.hai-captura__cuenta')) return;
      var enlace = document.createElement('a');
      enlace.className = 'hai-captura__cuenta';
      enlace.href = '/account';
      enlace.textContent = TEXTO_CUENTA;
      mensaje.insertAdjacentElement('afterend', enlace);
    });
  }

  var exitoEnPagina = exitosNewsletter().length > 0;
  if (exitoEnPagina) {
    marcar('correo', hoy());
    guardarSS('hai-correo-ahora', '1');
  }
  if (cambio) guardarLS('hai-quien', quien);

  function esCliente() { return !!quien.compro || (!!srv.sesion && pedidos > 0); }

  function calza(para) {
    switch (para) {
      case 'nuevo': return !srv.sesion && !esCliente() && !quien.correo;
      case 'correo': return !srv.sesion && !esCliente() && !!quien.correo && leerSS('hai-correo-ahora') !== '1';
      case 'cliente': return esCliente();
      case 'cliente_sesion': return !!srv.sesion && pedidos > 0;
      case 'cliente_sin_sesion': return !srv.sesion && esCliente();
      case 'tercero': return !!srv.sesion && pedidos === 2;
      case 'vip': return !!srv.sesion && pedidos >= 7;
      default: return false;
    }
  }

  /* ---- 3. Dónde y en qué estado está la página ---- */

  var movil = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  var plantilla = String(srv.plantilla || '');
  var esFicha = plantilla.indexOf('product') === 0;
  var esCarrito = plantilla === 'cart';

  function ocupada() {
    var b = document.body;
    return document.hidden || b.classList.contains('hidden') || b.classList.contains('search-modal--open') ||
      !!document.querySelector('body > .popup-wrapper.open');
  }

  function puedeIr(el) {
    var formato = el.getAttribute('data-hai-formato');
    if (movil && esFicha) return false;
    if (formato === 'aviso' && esCarrito) return false;
    if (formato === 'aviso' && !el.querySelector('.hai-aviso')) return false;
    if (el.getAttribute('data-hai-sin-carrito') === 'true' && carrito > 0) return false;
    return true;
  }

  document.addEventListener('hai:carrito', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') carrito = c.item_count;
  });
  document.addEventListener('cart:updated', function (e) {
    try {
      var c = e.detail && e.detail.cart;
      c = typeof c === 'string' ? JSON.parse(c) : c;
      if (c && typeof c.item_count === 'number') carrito = c.item_count;
    } catch (err) { /* el siguiente evento lo corrige */ }
  });

  /* ---- 4. Abrir ---- */

  var abierto = false;

  function abrir(el, forzar) {
    if (abierto) return;
    if (!forzar && (!puedeIr(el) || tieneCookie(el))) return;
    if (ocupada()) {
      window.setTimeout(function () { abrir(el, forzar); }, 1500);
      return;
    }
    cuandoExista(function () {
      if (abierto || typeof el.openPopup !== 'function') return;
      el.openPopup();
      abierto = true;
      guardarSS('hai-mensaje', clave(el));
      borrarSS('hai-continuar');
    });
  }

  function programar(el, inicio) {
    var segundos = parseInt(el.getAttribute('data-hai-segundos') || '0', 10) || 0;
    var desplazar = el.getAttribute('data-hai-desplazar') === 'true' || segundos === 0;
    var listo = false;
    var porcentaje = parseInt(((el.getAttribute('data-delay') || '').match(/(\d+)%/) || [])[1] || '50', 10) / 100;

    function disparar() {
      if (listo) return;
      listo = true;
      window.removeEventListener('scroll', alDesplazar);
      abrir(el);
    }
    function alDesplazar() {
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if ((window.scrollY || window.pageYOffset || 0) / max >= porcentaje) disparar();
    }

    if (segundos > 0) {
      var espera = Math.max(MIN_EN_PAGINA, segundos * 1000 - (Date.now() - inicio));
      window.setTimeout(disparar, espera);
    }
    if (desplazar) window.addEventListener('scroll', alDesplazar, { passive: true });
  }

  /* ---- 5. Al cargar ---- */

  function alListo() {
    var mensajes = Array.prototype.slice.call(document.querySelectorAll('promo-popup[data-hai-para]'));

    var inicio = parseInt(leerSS('hai-visita') || '0', 10);
    if (!inicio) {
      inicio = Date.now();
      guardarSS('hai-visita', String(inicio));
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.hai-aviso__boton');
      if (a && a.getAttribute('data-hai-destino') === 'entrar') guardarSS('hai-continuar', '1');
    });

    /* Revisión: ?hai_mensaje=<clave> y ?hai_captura=abrir|exito */
    var busqueda = window.location.search;
    var pedido = (busqueda.match(/[?&]hai_mensaje=([a-z0-9_]+)/) || [])[1];
    var captura = (busqueda.match(/[?&]hai_captura=(abrir|exito)(&|$)/) || [])[1];
    if (captura) pedido = 'hai_captura';
    if (pedido) {
      var elegido = mensajes.filter(function (el) { return clave(el) === pedido; })[0] ||
        document.querySelector('promo-popup[data-section-id$="__' + pedido + '"]');
      if (elegido) {
        if (captura === 'exito') {
          var form = elegido.querySelector('form');
          if (form && !form.querySelector('.success-color')) {
            var h = document.createElement('h3');
            h.className = 'subheading success-color';
            h.textContent = TEXTO_EXITO;
            form.insertBefore(h, form.firstChild);
          }
          anotarCuenta();
        }
        borrarCookie(elegido);
        cuandoExista(function () { if (typeof elegido.openPopup === 'function') elegido.openPopup(); });
        return;
      }
    }

    /* Tras dejar el correo: la salida a la cuenta y, si fue en un flyout, abrirlo para que se vea. */
    if (exitoEnPagina) {
      anotarCuenta();
      mensajes.forEach(function (el) { if (el.getAttribute('data-hai-para') === 'nuevo') fijarCookieLarga(el); });
      var conExito = mensajes.filter(function (el) { return !!el.querySelector('.success-color'); })[0];
      guardarSS('hai-mensaje', conExito ? clave(conExito) : 'correo');
      if (conExito) cuandoExista(function () { if (typeof conExito.openPopup === 'function') conExito.openPopup(); });
      return;
    }

    var continuar = leerSS('hai-continuar') === '1';
    var yaHubo = !!leerSS('hai-mensaje');

    var candidato = null;
    for (var i = 0; i < mensajes.length; i++) {
      var el = mensajes[i];
      var para = el.getAttribute('data-hai-para');
      if (yaHubo && !(continuar && para === 'cliente_sesion')) continue;
      if (!calza(para) || !puedeIr(el) || tieneCookie(el)) continue;
      candidato = el;
      break;
    }
    if (!candidato) return;

    if (continuar && candidato.getAttribute('data-hai-para') === 'cliente_sesion') {
      window.setTimeout(function () { abrir(candidato); }, 1200);
      return;
    }
    programar(candidato, inicio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alListo);
  } else {
    alListo();
  }
})();
